export default (text, length, breakText='…') => {
  if (text.length > length) {
    return text.substr(0, length - breakText.length) + breakText;
  }
  return text;
};
